import React, { useState, useContext, useEffect } from 'react';
import { Tabs, Tab, Container } from 'react-bootstrap';
import { UserInfo, DisclaimerSigned } from '../helper/Context';
import CreateVisualFlow from '../components/CreateVisualFlow';
import { Link, useLocation } from 'react-router-dom';

import { getVisualLifetimeHrs, getVisualLimit } from '../helper/BusinessLogic';

import './CreateVisualPage.css';

const UnsignedBody = (props) => {
    return (
        <div className="text-center text-white mt-5">
            <p>
                I understand that this software is not for clinical use, and
                that it is currently in beta. I also agree to the{" "}
                <Link to="/tos" target="_blank" className="visualization_link" style={{color: '#fdb99b'}}>
                    terms of use
                </Link>
                .
            </p>
            <button className="btn btn-primary" onClick={props.agree}>Agree</button>
        </div>
    );
};

const CreateVisualPage = (props) => {
    const { userInfo } = useContext(UserInfo);
    const { disclaimerSigned, setDisclaimerSigned } = useContext(DisclaimerSigned);
    const location = useLocation();
    const defaultTab = location.state?.defaultTab || 'upload';

    return (
        <div className="create-visual-page-container">
            <Container>
                <h1 className="gradient-text text-center mb-4">Create a New Visual</h1>
                {userInfo && userInfo.tier === "free" && !props.isOrg ? (
                    <h5 className="text-center text-white-50 font-italic mb-4">
                        Free plan: {getVisualLimit("free")} visuals max, links persist {Math.round(getVisualLifetimeHrs("free") / 24)} days
                    </h5>
                ) : null}

                {disclaimerSigned ? (
                    <CreateVisualFlow isOrg={props.isOrg} defaultTab={defaultTab} />
                ) : (
                    <UnsignedBody
                        agree={() => {
                            setDisclaimerSigned(true);
                        }}
                    />
                )}
            </Container>
        </div>
    );
};

export default CreateVisualPage; 